const HUB_FOLDER_KEY = 'Hub Locations';
const PICKUP_ZONE_FOLDER_KEY = 'Pick Up Zones';

const getHubsFromKml = (kml) => {
  const locs = [];
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(kml, 'text/xml');
  const folders = xmlDoc.querySelectorAll('Folder');
  folders.forEach((folder) => {
    const nameElements = folder.querySelectorAll('name');
    const folderName = nameElements.length ? nameElements[0].textContent : '';
    if (folderName === HUB_FOLDER_KEY) {
      const placemarks = Array.from(folder.querySelectorAll('Placemark'));
      placemarks.forEach((placemark) => {
        const name = placemark.querySelector('name').textContent;
        const coords = placemark
          .querySelector('Point')
          .querySelector('coordinates')
          .textContent
          .trim()
          .split(',');

        if (!coords || !coords.length) {
          console.error('no coordinates for location, cannot proceed');
          return;
        }
        if (!name) {
          console.error('no name for location, cannot proceed');
          return;
        }
        const locationData = {
          name,
          coordinates: [coords[0], coords[1]],
        };
        locs.push(locationData);
      });
    }
  });
  return locs;
};

const getPickupZonesFromKml = (kml) => {
  const zones = [];
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(kml, 'text/xml');
  const folders = xmlDoc.querySelectorAll('Folder');
  folders.forEach((folder) => {
    const nameElements = folder.querySelectorAll('name');
    const folderName = nameElements.length ? nameElements[0].textContent : '';
    if (folderName === PICKUP_ZONE_FOLDER_KEY) {
      const placemarks = Array.from(folder.querySelectorAll('Placemark'));
      placemarks.forEach((placemark) => {
        const name = placemark.querySelector('name').textContent;
        if (!name) {
          console.error('No name found');
          return;
        }

        const coordsText = placemark.querySelector('coordinates').textContent;
        if (!coordsText) {
          console.error('No coordinates found');
          return;
        }

        const coordsStrings = coordsText.trim().split(/\r?\n/);
        const coords = coordsStrings.map((coordsLine) => coordsLine.trim().split(',').slice(0, 2));
        if (!coords || !coords.length) {
          console.error('Could not parse coordinates');
          return;
        }

        const zoneData = { name, coordinates: [coords] };
        zones.push(zoneData);
      });
    }
  });
  return zones;
};

module.exports = {
  getHubsFromKml,
  getPickupZonesFromKml,
};
